import * as React from 'react';

const BadgeIcon = (props) => {
  const { rank, size = 18 } = props;
  const colorId = rank === 'gold' ? 'perfect' : rank === 'silver' ? 'elite' : 'great';

  const translateX = (26 - size) / 2 + 0.5;
  const translateY = (26 - size) / 2;

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="26" height="26" rx="13" fill={`url(#${colorId})`} />
      <g transform={`translate(${translateX}, ${translateY})`}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Outline/Diamond/Excellence">
            <path
              id="Vector"
              d="M12.7232 9.97142C12.6603 9.77756 12.4932 9.65257 12.2916 9.6231L10.349 9.34085L9.48047 7.58103C9.32377 7.31551 8.98158 7.22746 8.71607 7.38415C8.63504 7.43203 8.56741 7.49966 8.5192 7.58103L7.65067 9.34085L5.70804 9.6231C5.41507 9.66562 5.21217 9.93784 5.25502 10.2308C5.2721 10.3473 5.32701 10.4551 5.41105 10.5372L6.81663 11.9069L6.48482 13.8415C6.43493 14.1331 6.6308 14.41 6.92243 14.4599C7.03862 14.4797 7.15781 14.4609 7.26228 14.406L8.99933 13.4926L10.7364 14.406C10.9982 14.5436 11.3223 14.4429 11.4599 14.181C11.5148 14.0769 11.5336 13.9574 11.5138 13.8412L11.182 11.9066L12.5876 10.5368C12.7336 10.3945 12.7862 10.1816 12.7232 9.98739V9.97142ZM10.2331 11.336C10.1073 11.4593 10.0497 11.6364 10.0791 11.8102L10.275 12.9526L9.24944 12.4132C9.09341 12.3311 8.90692 12.3311 8.75089 12.4132L7.72533 12.9526L7.92121 11.8102C7.95067 11.6364 7.89308 11.4593 7.76719 11.336L6.93717 10.5271L8.08426 10.3604C8.2587 10.3349 8.40971 10.2254 8.48772 10.0671L9.00033 9.02812L9.51295 10.0671C9.59096 10.2251 9.74196 10.3349 9.91641 10.3604L11.0635 10.5271L10.2331 11.336ZM14.8929 2.57143H13.2857V2.03571C13.2857 1.73973 13.046 1.5 12.75 1.5C12.454 1.5 12.2143 1.73973 12.2143 2.03571V2.57143H9.53571V2.03571C9.53571 1.73973 9.29598 1.5 9 1.5C8.70402 1.5 8.46429 1.73973 8.46429 2.03571V2.57143H5.78571V2.03571C5.78571 1.73973 5.54598 1.5 5.25 1.5C4.95402 1.5 4.71429 1.73973 4.71429 2.03571V2.57143H3.10714C2.21987 2.57243 1.501 3.29129 1.5 4.17857V14.8929C1.501 15.7801 2.21987 16.499 3.10714 16.5H14.8929C15.7801 16.499 16.499 15.7801 16.5 14.8929V4.17857C16.499 3.29129 15.7801 2.57243 14.8929 2.57143ZM3.10714 3.64286H4.71429V4.17857C4.71429 4.47455 4.95402 4.71429 5.25 4.71429C5.54598 4.71429 5.78571 4.47455 5.78571 4.17857V3.64286H8.46429V4.17857C8.46429 4.47455 8.70402 4.71429 9 4.71429C9.29598 4.71429 9.53571 4.47455 9.53571 4.17857V3.64286H12.2143V4.17857C12.2143 4.47455 12.454 4.71429 12.75 4.71429C13.046 4.71429 13.2857 4.47455 13.2857 4.17857V3.64286H14.8929C15.1885 3.64319 15.4282 3.88292 15.4286 4.17857V5.25H2.57143V4.17857C2.57176 3.88292 2.8115 3.64319 3.10714 3.64286ZM14.8929 15.4286H3.10714C2.8115 15.4282 2.57176 15.1885 2.57143 14.8929V6.32143H15.4286V14.8929C15.4282 15.1885 15.1885 15.4282 14.8929 15.4286Z"
              fill="white"
              stroke="white"
              strokeWidth="0.0776415"
            />
          </g>
        </svg>
      </g>
      <defs>
        <linearGradient id="perfect" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4CA4AB" />
          <stop offset="0.36" stopColor="#ABE3E4" />
          <stop offset="0.49" stopColor="#B5ECED" />
          <stop offset="1" stopColor="#4CA4AB" />
        </linearGradient>
      </defs>
      <defs>
        <linearGradient id="elite" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#708189" />
          <stop offset="0.36" stopColor="#C8D1D4" />
          <stop offset="0.49" stopColor="#D5DEE2" />
          <stop offset="1" stopColor="#72838B" />
        </linearGradient>
      </defs>
      <defs>
        <linearGradient id="great" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F4B513" />
          <stop offset="0.36" stopColor="#FFDF6D" />
          <stop offset="0.49" stopColor="#FFE791" />
          <stop offset="1" stopColor="#F4B513" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BadgeIcon;
